import { Common } from "@stockbit/ui";
import styled from "styled-components";

const { Input } = Common;

export const InputContainer = styled.div`
  width: 24px;
  overflow: hidden;
  border: 1px solid rgb(218, 218, 218);
`;

export const InputNumber = styled.input`
  border: none;
  width: 24px;
  height: 36px;
  font-size: 16px;
  text-align: center;
  padding: 0;
  outline: none;
`;
